<template>
  <div class="join-personal-data">
    <v-row>
      <v-col class="join-personal-data__form-col">
        <h5 class="join-personal-data__form-label">Primary Information</h5>
        <JoinForm
          :processing="processing"
          :isDeveloper="true"
          acceptance
          submit-name="NEXT STEP"
          @submit="submitDeveloper"
        />
      </v-col>
      <v-col>
        <StepSlider/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import JoinForm from '@/components/JoinForm.vue';
import StepSlider from '@/components/Developer/Join/StepSlider.vue';

export default {
  components: {
    JoinForm,
    StepSlider,
  },

  props: {
    processing: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isSubmitProcessing: false,
    };
  },

  methods: {
    submitDeveloper(developerData) {
      this.$emit('submit', developerData);
    },
  },
};
</script>

<style lang="scss" scoped>
.join-personal-data {
  margin-top: 12px;

  &__form-col {
    @include desktop {
      padding-right: 80px;
    }
  }

  &__form-label {
    font-size: 12px;
    font-weight: 600;
    padding-bottom: 8px;
    margin-bottom: 16px;
    border-bottom: 1px solid #E2E6EA;

  }
}
</style>
